import { render, staticRenderFns } from "./MailContactConfirm.vue?vue&type=template&id=52db3a9c&scoped=true&"
import script from "./MailContactConfirm.vue?vue&type=script&lang=js&"
export * from "./MailContactConfirm.vue?vue&type=script&lang=js&"
import style0 from "./MailContactConfirm.vue?vue&type=style&index=0&id=52db3a9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52db3a9c",
  null
  
)

export default component.exports